import { render, staticRenderFns } from "./CompanyPage.vue?vue&type=template&id=29e4b4c8"
import script from "./CompanyPage.vue?vue&type=script&lang=js"
export * from "./CompanyPage.vue?vue&type=script&lang=js"
import style0 from "./CompanyPage.vue?vue&type=style&index=0&id=29e4b4c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports